"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WizardContainer = void 0;
var _auth = require("@ori/auth");
var _react = require("react");
var _contexts = require("../contexts");
var _useSubscriptionLogic = require("../hooks/useSubscriptionLogic");
var _logger = require("../logger");
var _jsxRuntime = require("react/jsx-runtime");
const WizardContainer = ({
  onBehalfCustomerId,
  placementFromUrl,
  uriTemplateFromUrl,
  children
}) => {
  const {
    customerType,
    eventCustomerId,
    handleClose,
    handleCloseFeedback,
    handleError,
    handleOpenFeedback,
    handleSave,
    isFeedbackOpen,
    key,
    open,
    placement,
    productCode,
    uriTemplate,
    wizardType
  } = (0, _useSubscriptionLogic.useSubscriptionLogic)({
    placementFromUrl,
    uriTemplateFromUrl
  });
  const {
    customerId
  } = (0, _auth.useToken)();
  (0, _logger.logDebug)('WizardContainer data:', {
    wizardType,
    productCode,
    key
  });
  const value = (0, _react.useMemo)(() => ({
    customerId: eventCustomerId ?? onBehalfCustomerId ?? customerId,
    customerType,
    handleCloseFeedback,
    handleOpenFeedback,
    id: key,
    isFeedbackOpen,
    onClose: handleClose,
    onError: handleError,
    onSave: handleSave,
    open,
    placement,
    productCode,
    uriTemplate,
    wizardType
  }), [customerId, customerType, eventCustomerId, handleClose, handleCloseFeedback, handleError, handleOpenFeedback, handleSave, isFeedbackOpen, key, onBehalfCustomerId, open, placement, productCode, uriTemplate, wizardType]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.WizardProvider, {
    value: value,
    children: children
  });
};
exports.WizardContainer = WizardContainer;
